import QuestPage from "./QuestPage";

export default function Quests() {
  return <QuestPage groupKey="quests" />;
}
